export default function getAvatarLetters(name) {
  let letters = name.match(/\b(\w)/g).join('');
  if (letters.length > 1) {
    letters = letters.slice(0, 2);
  }
  return letters;
}



// WEBPACK FOOTER //
// ./src/js/libs/AvatarLetters.js